import { Block } from "../../../document-writer/src/components/editor/Editor";
import { SavedBlockData } from "@/types/document";

/**
 * Extract only the essential block data for saving
 * This removes React component state and other unnecessary data
 */
export function extractBlockData(blocks: Block[]): SavedBlockData[] {
  return blocks.map(block => ({
    id: block.id,
    type: block.type,
    content: block.content,
    metadata: block.metadata,
  }));
}

/**
 * Convert saved block data back to Block format
 * This is useful when loading saved data
 */
export function convertToBlocks(savedBlocks: SavedBlockData[]): Block[] {
  return savedBlocks.map(block => ({
    id: block.id,
    type: block.type,
    content: block.content,
    metadata: block.metadata,
  }));
}
